// = Libs =
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

// = Styles =
// = Imports =
import Page from '@/common/containers/page/page';
import Container from '@/common/containers/container/container';
import { BEFullPollModel, usePollData } from '@/services/poll.service';
import Jumbotron from '@/common/components/core/jumbotron/jumbotron';
import { formatPollStatus } from '@/helpers/formatStatus';
import classes from './author-poll.module.scss';
import PollReports from '@/pages/poll/author-poll/tabs/poll-reports/poll-reports';
import PollInfo from '@/pages/poll/componens/poll-info/poll-info';
import PollSettingsTab from '@/pages/poll/author-poll/tabs/poll-settings/poll-settings-tab';
import PollQuestions from '@/pages/poll/author-poll/tabs/poll-questions/poll-questions';

const AuthorPoll: FC = () => {
  const { id, mode } = useParams<{ id: string; mode: string }>();
  const [tabIndex, setTabIndex] = useState(0);

  const pollData: BEFullPollModel = usePollData(id);

  const isAtOrganization = pollData?.status === 'organization';

  return (
    <Page>
      <Jumbotron
        title={pollData?.title}
        previousPath="/"
        previousPage="Мониторинги данных"
        label={formatPollStatus(pollData?.status)?.text}
        labelColor={formatPollStatus(pollData?.status)?.color}
      />
      <section className={classes['page-monitoring']}>
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
          <TabList className={classes['tab-list']}>
            <Container>
              <Tab
                className={classes.tab}
                selectedClassName={classes['tab--selected']}>
                Описание
              </Tab>
              <Tab
                className={classes.tab}
                selectedClassName={classes['tab--selected']}>
                Настройки
              </Tab>
              {isAtOrganization ? (
                <Tab
                  className={classes.tab}
                  selectedClassName={classes['tab--selected']}>
                  Вопросы
                </Tab>
              ) : (
                <Tab
                  className={classes.tab}
                  selectedClassName={classes['tab--selected']}>
                  Отчеты
                </Tab>
              )}
            </Container>
          </TabList>
          <Container>
            <div>
              <div>
                <TabPanel>
                  <PollInfo {...pollData} />
                </TabPanel>
                <TabPanel>
                  <PollSettingsTab
                    canPublish={isAtOrganization}
                    pollData={pollData}
                  />
                </TabPanel>
                {isAtOrganization ? (
                  <TabPanel>
                    <PollQuestions pollId={id} />
                  </TabPanel>
                ) : (
                  <TabPanel>
                    <PollReports />
                  </TabPanel>
                )}
              </div>
            </div>
          </Container>
        </Tabs>
      </section>
    </Page>
  );
};

export default AuthorPoll;
